export const routeNames = {
  DASHBOARD: 'dashboard',
  TRANSACTION: 'transactions',
  LINX: 'linx',
  CUSTOMER: 'customers',
  COUNTERPARTY: 'counterparties',
  SETTINGS: 'settings',
  ACCOUNT_AUTH: 'account',
  CARDS: 'cards',
  EARNED_WAGE: 'earned-wage',
  INSIGHTS: 'insights',
  MOCKETBNK: 'mocketbnk',
  EXCEPTION_MANAGEMENT: 'exception-management',
};
